import React from 'react'

const DownLoadIcon = () => {
  return (
    <svg
      width="12"
      height="15"
      viewBox="0 0 12 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.05 13.4231H10.95C11.2538 13.4231 11.5 13.6642 11.5 13.9615C11.5 14.2259 11.3054 14.4457 11.0489 14.4913L10.95 14.5H1.05C0.746243 14.5 0.5 14.2589 0.5 13.9615C0.5 13.6972 0.694563 13.4773 0.951137 13.4318L1.05 13.4231H10.95H1.05ZM5.90114 0.508675L6 0.5C6.27001 0.5 6.49457 0.690481 6.54114 0.941672L6.55 1.03846V10.5068L9.50018 7.61944C9.6911 7.43253 9.98747 7.41176 10.2018 7.55714L10.278 7.61944C10.4689 7.80636 10.4901 8.09651 10.3416 8.30637L10.278 8.38094L6.38891 12.1884C6.19799 12.3754 5.90162 12.3961 5.68726 12.2507L5.61109 12.1884L1.722 8.38094C1.50722 8.17066 1.50722 7.82973 1.722 7.61944C1.91293 7.43253 2.20929 7.41176 2.42365 7.55714L2.49982 7.61944L5.45 10.5068V1.03846C5.45 0.77412 5.64456 0.554268 5.90114 0.508675L6 0.5L5.90114 0.508675Z"
        fill="#57C9A7"
      />
    </svg>
  )
}

export default DownLoadIcon
